import React from "react";
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";

// Per-recipient outcomes Azure Communication Services reports through Event
// Grid, stamped onto the run item by /api/email/delivery-report. Kept in step
// with DELIVERY_STATUS in backend/src/models/emailDeliveryModel.js.
//
// Only `Delivered` means the recipient's mail server accepted it. Everything
// except that and `Expanded` (a distribution list fanning out — an
// intermediate step, not a result) means the statement did not arrive.
const DELIVERY_BADGES = {
  Delivered: "success",
  Bounced: "danger",
  Failed: "danger",
  Suppressed: "warning",
  Quarantined: "warning",
  FilteredSpam: "warning",
  Expanded: "info",
};

const DELIVERY_LABELS = {
  FilteredSpam: "Filtered as spam",
};

/**
 * What Azure said happened to this item's email, if anything yet.
 *
 * Sending only gives an acceptance receipt, so an EMAILED item with no report
 * is genuinely "Pending" rather than delivered — saying so is the point of the
 * column. Items that never reached the send stage show nothing at all.
 */
export function DeliveryStatusCell({ item }) {
  if (!item.deliveryStatus) {
    if (item.emailOperationId) {
      return (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip>
              Azure accepted the message; no delivery report received yet.
            </Tooltip>
          }
        >
          <Badge bg="secondary">Pending</Badge>
        </OverlayTrigger>
      );
    }
    return <span className="text-muted">-</span>;
  }

  const label = DELIVERY_LABELS[item.deliveryStatus] || item.deliveryStatus;
  const reportedAt = item.deliveryReportedAt
    ? new Date(item.deliveryReportedAt).toLocaleString("en-GB")
    : null;

  const badge = (
    <Badge bg={DELIVERY_BADGES[item.deliveryStatus] || "secondary"}>
      {label}
    </Badge>
  );

  if (!item.deliveryDetail && !reportedAt) return badge;

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip>
          {item.deliveryDetail && <div>{item.deliveryDetail}</div>}
          {reportedAt && <div>Reported {reportedAt}</div>}
        </Tooltip>
      }
    >
      {badge}
    </OverlayTrigger>
  );
}

export default DeliveryStatusCell;
